
import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachDangKyNganh2ActionsObj } from "../../action-types/quan-ly-nganh-2/IDanhSachDangKyNganh2Actions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachDangKyNganh2Actions = {
   ...generateActions(eDanhSachDangKyNganh2ActionsObj, "DANH_SACH_DANG_KY_NGANH_2"),
   ...generateActionForKey(eDanhSachDangKyNganh2ActionsObj, "DANH_SACH_DANG_KY_NGANH_2", "DUYETS_SUCCESS", (m) => { NotifyHelper.Success("Thành công"); }),
   ...generateActionForKey(eDanhSachDangKyNganh2ActionsObj, "DANH_SACH_DANG_KY_NGANH_2", "DUYETS_ERROR", (m) => { NotifyHelper.Error("Duyệt thất bại"); }),
}